module.exports = function () {
    if ( document.querySelector(".wpcf7") && document.querySelector('.form-success-sent') ) {
        const form = document.querySelector(".wpcf7");
        const formSuccesssent = document.querySelector('.form-success-sent');

        // close success sent popup
        if ( formSuccesssent.querySelector(".form-success-sent__close") ) {
            const closeBtn = formSuccesssent.querySelector(".form-success-sent__close");

            closeBtn.addEventListener("click", () => {
                formSuccesssent.classList.add("hidden");
            })
        }

        // contact form 7 submit event
        form.addEventListener("wpcf7submit", function (event) {
            if ( !form.querySelector("form").classList.contains("invalid") ) {
                formSuccesssent.classList.remove("hidden");
                
                if (document.querySelector(".textarea-count-text") )
                    document.querySelector(".textarea-count-text").textContent = "0/500";

                // replace text
                if (
                    document.querySelector(".form-success-sent__content") &&
                    document.querySelector(".form-success-sent__content").textContent.includes("[name]")
                ) {
                    const inputs = event.detail.inputs;
                    const content = document.querySelector(".form-success-sent__content");
                    let name = '';

                    for ( let i = 0; i < inputs.length; i++ ) {
                        if ( 'first-name' === inputs[i].name ) {
                            name = inputs[i].value;
                            break;
                        }
                    }

                    content.innerHTML = content.innerHTML.replaceAll("[name]", name);
                }
            }
            else {
                // error sent email!
            }
        }, false)
    }
    
    // textarea count
    if ( document.querySelector(".textarea-count") ) {
        const items = document.querySelectorAll(".textarea-count");
        
        items.forEach(item => {
            const maxLength = 500;
            
            function updateTextCount() {
                element.innerHTML = `${item.value.length}/${maxLength}`;
            }
            
            item.setAttribute("maxlength", maxLength);
            
            const element = document.createElement("span");
            element.classList.add("textarea-count-text");
            updateTextCount();
            
            item.parentNode.appendChild(element);
            
            item.addEventListener("input",  updateTextCount);
        })
    }
    
    // contact file
    if ( document.querySelector(".contact-file") ) {
        document.querySelectorAll(".contact-file").forEach(item => {
            const input = item.querySelector("input");
            const message = item.querySelector(".contact-file-content-message");
            let messageText = message.textContent;
            const uploadedText = document.querySelector(".limit-text-uploaded");
            
            input.addEventListener("change", (e) => {
                if ( e.target.files.length > 0 ) {
                    message.textContent = messageText;
                    item.classList.remove("drag-enter");
                    
                    console.log(e.target.files[0])
                    uploadedText.textContent = `Uploaded (${(e.target.files[0].size / 1000 / 1000).toFixed(1)} MB) `;
                    createFileView(e.target.files[0]);
                }
            })
            
            input.addEventListener("dragenter", () => {
                item.classList.add("drag-enter");
                message.textContent = "Drop file";
            })

            input.addEventListener("dragleave", () => {
                item.classList.remove("drag-enter");
                message.textContent = messageText;
            })
            
            function createFileView(file) {
                document.querySelectorAll(".file-item").forEach(item => item.remove());
                const element = document.createElement("div");
                element.classList.add("file-item");
                element.innerHTML = `<span>${file.name}</span> <button type="button" class="file-item-button"></button>`;
                
                item.appendChild(element);
            }
            
            
            item.addEventListener("click", (e) => {
                if ( e.target.classList.contains("file-item-button") ) {
                    input.value = null;
                    item.querySelector(".file-item").remove();
                    uploadedText.textContent = "";
                }
            })
        })
    }
    
    if ( document.querySelector(".fmg-form") ) {
        document.querySelectorAll(".fmg-form").forEach(item => {
            const message = item.querySelector(".success-message");
            
            item.addEventListener("wpcf7submit", function (event) {
                if ( item.querySelector("form").classList.contains("sent") )
                    message.style.display = null;
                
                    // clear form
                    if ( document.querySelector(".file-item") ) {
                        document.querySelectorAll(".file-item").forEach(item=> item.remove());
                        document.querySelector(".limit-text-uploaded").textContent = "";
                    }
                    
                    if (document.querySelector(".textarea-count-text") )
                    document.querySelector(".textarea-count-text").textContent = "0/500";
            })
            
            message.querySelector("button").addEventListener("click", () => {
                message.style.display = "none";
            })
        })
    }
}